import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { APConfigService } from './ap-config.service';

export const apConfigResolver: ResolveFn<void> = () => {
  return inject(APConfigService).setApConfig();
};
